<template>
  <div>
    <add-fee
      :is-active.sync="isUpdatingFees"
      :url="url"
      :method="method"
      :feeable="selectedFee"
      :hasSendingCountry="hasSendingCountry"
      :hasReceivingCountry="hasReceivingCountry"
      @submitted="feesUpdated"
    />

    <data-table title="Fees" :url="fees_url" :headers="headers" :fields="fields" ref="table">
      <template slot="action.icons">
        <v-btn color="primary" @click="addFee">
          <v-icon color="light-blue lighten-4">
            mdi-plus-outline
          </v-icon>
          Add Fee
        </v-btn>
      </template>
      <!-- <template slot="item.sending_country.name" slot-scope="{ item }">
        <span v-if="item.sending_country.name">
          {{ item.sending_country.name }}
        </span>
      </template>
      <template slot="item.receiving_country.name" slot-scope="{ item }">
        <span v-if="item.receiving_country.name">
          {{ item.receiving_country.name }}
        </span>
      </template> -->
      <template slot="item.actions" slot-scope="{ item }">
        <v-icon medium title="Edit Fee" @click.stop="updateFee(item)">
          mdi-pencil
        </v-icon>
        <v-icon medium title="Delete Fee" @click.stop="deleteItem(item)">
          mdi-delete
        </v-icon>
      </template>
    </data-table>
  </div>
</template>

<script>
import AddFee from "./form";

export default {
  props: {
    fees_url: { required: true, type: String },
    hasSendingCountry: { default: false, type: Boolean },
    hasReceivingCountry: { default: false, type: Boolean },
  },
  components: { AddFee },
  data() {
    return {
      isAddingFee: false,
      isUpdatingFees: false,
      dialogDelete: false,
      method: "post",
      url: this.fees_url,
      selectedFee: {},
      fields: {
        value: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
    };
  },
  watch: {
    fees_url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
  },
  computed: {
    headers() {
      let values = {
        min: "Min Amount (Danacoins)",
        max: "Max Amount (Danacoins)",
        value: "Value",
        actions: "Actions",
      };
      if (this.hasSendingCountry) {
        values = { "sending_country.name": "Sending Country", ...values };
      }
      if (this.hasReceivingCountry) {
        values = { "receiving_country.name": "Receiving Country", ...values };
      }

      return values;
    },
  },
  methods: {
    addFee() {
      this.url = this.fees_url;
      this.method = "post";
      this.setSelectedFee();
      this.isUpdatingFees = true;
    },
    updateFee(fee) {
      this.url = this.fees_url + `/${fee.id}`;
      this.method = "put";
      this.setSelectedFee(fee);
      this.isUpdatingFees = true;
    },
    setSelectedFee(fee = {}) {
      this.selectedFee = fee;
      return;
    },
    feesUpdated({ message }) {
      this.isUpdatingFees = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
    deleteItem(item) {
      Notify.confirm(`The fee will be removed.`).then(() => {
        this.$http.delete(`${this.fees_url}/${item.id}`).then(() => {
          Notify.success("Transaction fee was successfully deleted.");
          // refresh the table data
          this.$refs.table.fetchData();
        });
      });
    },
  },
};
</script>
